import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ControlRef} from '@aviary/forms/fields/form-fields.types';
import {getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {provideControlRefTokenFor} from '@aviary/providers/control-ref.provider';
import {hasNoValue, isNumber} from '@aviary/store/common/typing.helpers';

@Component({
  selector: 'mx-currency-form-field',
  template: `
    <mx-input-form-field [fieldName]="fieldName" [formGroup]="formGroup" [overrideLabel]="overrideLabel" [externalLabel]="externalLabel"
                         [includeClearButton]="includeClearButton" [placeholder]="placeholder" [includeDollarSign]="true" [alignRight]="alignRight"
                         (inputBlurred)="onInputBlur()" [enabled]="enabled"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideControlRefTokenFor(CurrencyFormFieldComponent)],
  imports: [InputFormFieldComponent]
})
export class CurrencyFormFieldComponent implements OnInit, ControlRef {

  @Input() public fieldName: string;
  @Input() public overrideLabel: string;
  @Input() public formGroup: ExtendedFormGroup;
  @Input() public placeholder = '';
  @Input() public includeClearButton = true;
  @Input() public externalLabel = false;
  @Input() public alignRight = false;
  @Input() public enabled = true;

  public control: ExtendedFormControl;  // It's tempting to rename this to "formControl", but that's a reserved name and causes confusing errors.  So don't.

  public ngOnInit(): void {
    this.control = getExtendedControlFrom(this.formGroup, this.fieldName);
    this.updateFormattingFor(this.control.value);
  }

  public onInputBlur(): void {
    this.updateFormattingFor(this.control.value);
  }

  private updateFormattingFor(value: string | number | null | undefined): void {
    if (value === '' || hasNoValue(value)) return;

    this.control.setValue(toStringCurrency(value));
  }
}

export function toStringCurrency(value: string | number | null | undefined): string {
  if (value === '' || hasNoValue(value)) return '';

  const numericValue: number = parseFloat(String(value).replace(/[^\d.-]/g, ''));

  return isNumber(numericValue) ? numericValue.toFixed(2) : '';  // Avoiding NaN result from parseFloat().
}
